import React from "react";
import PropTypes from "prop-types";

// <defs>
//  <style>.cls-1,.cls-2{fill:none;stroke:#231f20;}.cls-1{stroke-width:1.04px;}.cls-2{stroke-width:1.08px;}</style>
// </defs>

const Bag = ({ className, color }) => {
  switch (color) {
    case `bone`:
      color = `#f4eee3`;
      break;

    default:
      break;
  }

  return (
    <svg className={className} viewBox="0 0 16.77 17.16">
      <g id="Layer_5" data-name="Layer 5">
        <polygon
          className="cls-1"
          points="15.96 16.43 0.73 16.43 1.73 5.05 14.96 5.05 15.96 16.43"
          fill="none"
          stroke={color}
          strokeWidth={1}
        />
        <path
          className="cls-2"
          d="M4.77,4.78a3.69,3.69,0,0,1,7.37,0"
          fill="none"
          stroke={color}
          strokeWidth={1}
        />
      </g>
    </svg>
  );
};

Bag.defaultProps = {
  className: ``,
  color: `black`
};

Bag.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default Bag;
